import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { api } from '@app/utils/api';
import { BI_BASE_URL } from '@app/contstants/endpoints';
import { ManagersTeamTableResponse } from '../types';
import { QUERY_KEY_MANAGER_PERFORMANCE } from '../query-keys';

const getManagersTeamTable = async (): Promise<ManagersTeamTableResponse> => {
  const { data } = await api.get<ManagersTeamTableResponse>(`${BI_BASE_URL}/managers/team/table`);

  return data;
};

export const useGetManagersTeamTable = () => {
  return useQuery({
    queryKey: [QUERY_KEY_MANAGER_PERFORMANCE.MANAGERS_TEAM_TABLE],
    queryFn: getManagersTeamTable,
  });
};
